import { BottomBar, SaveBar, Modal, Box, Icon, Gap } from '@salecycle/ui-component-library';
import { Campaign } from 'entities/campaign';
import { FC, useState } from 'react';
import { connect } from 'react-redux';
import { Selectors as Router } from 'router';
import { State } from 'store';
import { Actions } from '../../../state/editor';
import { Selectors } from 'sections/campaigns/state/campaigns';
import StateBadge from '../../components/StateBadge';
import { getActivityState } from 'entities/lifecycle/activityState';

interface OwnProps {
  saveButtonPermanentlyDisabled?: boolean;
  hasUnsavedChanges: boolean;
  hasMissingFields: boolean;
}

interface StateProps {
  siteId: string;
  campaignId: string;
  campaign: Campaign;
  originalCampaign: Campaign;
}

interface DispatchProps {
  discard: () => void;
  save: () => void;
  saveAndRedirect: (siteId: string) => void;
}

export type IProps = OwnProps & StateProps & DispatchProps;

export const Toolbar: FC<IProps> = props => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const handleSave = (backToCampaigns?: boolean) => {
    if (backToCampaigns) {
      props.saveAndRedirect(props.siteId);
    } else {
      props.save();
      setIsModalOpen(false);
    }
  };
  return (
    <>
      <BottomBar>
        <SaveBar
          onSaveButtonClicked={() => setIsModalOpen(true)}
          onDiscardButtonClicked={props.discard}
          enableSaveButton={
            !props.saveButtonPermanentlyDisabled && !(!props.hasUnsavedChanges || props.hasMissingFields)
          }
        />
      </BottomBar>
      <Modal
        heading="Save Campaign?"
        isOpen={isModalOpen}
        variation="clean"
        okButtonLabel="Save &amp; Exit"
        onOkButtonClicked={() => handleSave(true)}
        cancelButtonLabel="Save &amp; Continue Editing"
        onCancelButtonClicked={() => handleSave(false)}
        onCloseButtonClicked={() => setIsModalOpen(false)}
      >
        {getActivityState(props.originalCampaign) !== getActivityState(props.campaign) && (
          <>
            <Box>
              <StateBadge lifeCycle={props.originalCampaign} />
              <Box padding="1rem">
                <Icon icon="angle-double-right" />
              </Box>
              <StateBadge lifeCycle={props.campaign} />
            </Box>
            <Gap bottom={10} />

            <p>
              Your campaign will move from &apos;{getActivityState(props.originalCampaign)}&apos; to &apos;
              {getActivityState(props.campaign)}&apos; with the latest changes
            </p>
          </>
        )}
        <p>Would you like to exit to the campaigns list or save and continue editing?</p>
      </Modal>
    </>
  );
};
const mapStateToProps = (state: State): StateProps => {
  const campaignId = Router.getCampaignId(state);
  const siteId = Router.getSiteId(state);
  const campaign = Selectors.getUpdatedEntity(state, campaignId);

  return {
    originalCampaign: Selectors.getEntity(state, campaignId),
    campaign,
    siteId,
    campaignId,
  };
};

const actionCreators: DispatchProps = {
  discard: Actions.discardChanges,
  save: Actions.saveChanges,
  saveAndRedirect: Actions.saveChangesAndRedirect,
};

export default connect(mapStateToProps, actionCreators)(Toolbar);
